"use strict";
/// <reference path="irep.js" />

IREP.rcispromo = (function () {
    var init = function (options) {
        $("#Participate").click(ProcessOptIn);
    };

    var ProcessOptIn = function () {
        var isOptedIn = false;
        IREP.callApi("/rcispromo/isoptedin", "GET")
            .done(function (data) {
                isOptedIn = data.isOptedIn;
                if (!isOptedIn) {
                    OptUserIntoContest();
                } else {
                    DisplayPostOptinInfo();
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                IREP.displayError("Optin check error: " + errorThrown);
            });
    };


    var OptUserIntoContest = function () {
        var countryCode = IREP.options.user.countryCode.toLowerCase();
        if (countryCode === "ru" || countryCode === "kz" || countryCode === "by") {
            
            IREP.callApi("/rcispromo/optin", "POST")
                .done(function () {
                    DisplayPostOptinInfo();
                })
                  .fail(function (jqXHR, textStatus, errorThrown) {
                      IREP.displayError("Opt in error: " + errorThrown);
                  });
        }
    };

    var DisplayPostOptinInfo = function() {
        $("#ParticipateValueContainer > div").remove();
        $("#ParticipateValueContainer").append("<div><p>Вы зарегистрированы на участие в конкурсе</p></div>");
        GetPointMeter();
        FillLeaderboard();
    };

    var GetPointMeter = function () {
        IREP.callApi("/rcispromo/participant", "GET")
        .done(function (data) {
            $("#PointsMeterContainer").append("<div id='pointsMeter'>Вы заработали <br /><span id='pointsTotal'>" + data.promoParticipant.pointsEarned + "</span><br /> баллов за период конкурса</div>");
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            IREP.displayError("Failed to retrieve participant: " + errorThrown);
        });
    };

    var FillLeaderboard = function () {
        IREP.callApi("/rcispromo/leaderboard", "GET")
            .done(function (data) {
                var content = "<div>Таблица лидеров</div>";
                content += "<div id='leaderboard'><table><tr><th>№</th><th>Имя</th><th>Сеть</th><th>Город</th><th>Заработано баллов</th></tr>";
                for (var i = 0, len = data.leaderboardParticipants.length; i < len; i++) {
                    var participant = data.leaderboardParticipants[i];
                    var name = participant.firstName + " " + participant.lastName.substring(0, 1) + ".";
                    var row = "<tr><td>" + (i + 1) + "</td><td>" + name + "</td><td>" + participant.chainName + "</td><td>" + participant.city + "</td><td>" + participant.pointsEarned + "</td></tr>";
                    content += row;
                }
                content += "</table></div>";
                $("#LeaderboardContainer").append(content);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                IREP.displayError("Failed to retrieve leaderboard:" + errorThrown);
            });
    };
    return {
        init: init
    };
})();